/** Swiss German orthography — no ß, use ss */
export const de = {
  brand: {
    name: 'PRIVATUM',
    tagline: 'Confidential by design.',
    taglineAlt1: 'Berufsgeheimnis verdient professionelle Infrastruktur.',
    taglineAlt2: 'Ihre Geheimnisse waren nie unsere.',
  },
  nav: {
    home: 'Startseite',
    features: 'Funktionen',
    security: 'Sicherheit',
    pricing: 'Preise',
    verticals: 'Branchen',
    login: 'Anmelden',
    getStarted: 'Jetzt starten',
    dashboard: 'Dashboard',
  },
  hero: {
    title: 'Ihre Mandanten vertrauen Ihnen ihre sensibelsten Informationen an.',
    titleHighlight: 'Lassen Sie sie diese nicht per E-Mail senden.',
    subtitle: 'Privatum gibt Anwälten, Ärzten und Vertrauenspersonen einen sicheren, wissensfreien Kanal für den Empfang vertraulicher Dokumente.',
    cta: 'Sicher starten',
    ctaSecondary: 'So funktioniert es',
  },
  problem: {
    title: 'Das Problem mit E-Mail-Anhängen',
    subtitle: 'Jede Kopie ist eine Angriffsfläche. Weniger Kopien, weniger Risiko, mehr Kontrolle.',
    emailPath: 'Mandant → E-Mail-Anbieter → Mailserver → Postfach → Gerät → Backup → DMS',
    privatumPath: 'Mandant → Auf dem Gerät verschlüsselt → Privatum → Autorisierter Fachperson',
    emailLabel: 'Heute: 7 Kopien, 7 Risiken',
    privatumLabel: 'Mit Privatum: verschlüsselt, direkt, kontrolliert',
  },
  howItWorks: {
    title: 'So einfach wie E-Mail. Sicherer als alles andere.',
    step1Title: 'Sicheren Kanal erstellen',
    step1Desc: 'Registrieren Sie sich in 90 Sekunden. Erhalten Sie Ihren persönlichen Sicheren Posteingang unter privatum.ch/ihr-name.',
    step2Title: 'Mandant lädt hoch',
    step2Desc: 'Kein Konto, keine App, kein technisches Wissen nötig. Dateien werden auf dem Gerät des Absenders verschlüsselt.',
    step3Title: 'Vertraulich empfangen',
    step3Desc: 'Nur Sie können die Dokumente entschlüsseln. Privatum kann sie nicht lesen. Niemand sonst kann es.',
  },
  upload: {
    title: 'SICHERER DOKUMENTENTRANSFER',
    sendingTo: 'Sie senden Dokumente sicher an:',
    dragDrop: 'Dateien hierher ziehen',
    chooseFiles: 'Dateien auswählen',
    yourName: 'Ihr Name (optional)',
    yourEmail: 'Ihre E-Mail (optional)',
    message: 'Nachricht (optional)',
    encryption: 'Ihre Dateien werden auf Ihrem Gerät verschlüsselt, bevor sie hochgeladen werden. Privatum kann sie nicht lesen.',
    submit: 'Verschlüsseln & sicher senden',
    encrypting: 'Wird lokal verschlüsselt …',
    uploading: 'Verschlüsselte Daten werden hochgeladen …',
    delivered: 'Sicher zugestellt.',
    plgLine: 'Empfangen Sie selbst vertrauliche Dokumente? Erstellen Sie Ihren eigenen sicheren Privatum-Kanal.',
    accessCode: 'Zugangscode',
    accessCodeHint: 'Bitte geben Sie den Code ein, den Sie von Ihrer Fachperson erhalten haben.',
  },
  pricing: {
    title: 'Einfache, transparente Preise',
    subtitle: 'Mandanten sind immer kostenlos und unbegrenzt.',
    monthly: '/Monat',
    annual: 'Jahreszahlung: 2 Monate gratis',
    solo: {
      name: 'SOLO',
      price: 'CHF 19',
      desc: 'Für Einzelpraktiker',
      features: [
        'Persönlicher Sicherer Posteingang',
        'Unbegrenzte Sichere Links',
        '20 GB verschlüsselter Zwischenspeicher',
        'Automatische Löschung',
        'Professionelles Profil',
        'Basis-Aktivitätsprotokoll',
      ],
    },
    professional: {
      name: 'PROFESSIONAL',
      price: 'CHF 49',
      desc: 'Für kleine Kanzleien und Praxen',
      popular: 'Beliebteste Wahl',
      features: [
        'Bis zu 5 Benutzer',
        'Team-Posteingang',
        '100 GB verschlüsselter Speicher',
        'Eigenes Branding',
        'Erweiterte Aufbewahrungsregeln',
        'Team-Berechtigungen',
        'Website-Widget',
      ],
    },
    practice: {
      name: 'PRAXIS',
      price: 'CHF 149',
      desc: 'Für grössere Kanzleien und Praxen',
      features: [
        'Bis zu 20 Benutzer',
        '500 GB verschlüsselter Speicher',
        'Rollen & Berechtigungen',
        'API-Zugang',
        'DMS-Integrationen',
        'Erweiterte Prüfprotokolle',
        'Prioritäts-Support',
      ],
    },
    enterprise: {
      name: 'ENTERPRISE',
      price: 'Auf Anfrage',
      desc: 'Für Grossunternehmen und Konzerne',
      features: [
        'Private Relay-Infrastruktur',
        'Dedizierter Schweizer Speicher',
        'Kundeneigener Speicher',
        'SSO-Integration',
        'Individuelle Aufbewahrung',
        'On-Premise-Option',
        'SLA & Compliance-Support',
      ],
    },
    cta: 'Jetzt starten',
    ctaEnterprise: 'Kontaktieren Sie uns',
  },
  verticals: {
    title: 'Für jeden Vertrauensberuf',
    lawyers: 'Anwälte',
    healthcare: 'Gesundheitswesen',
    psychotherapy: 'Psychotherapie',
    fiduciary: 'Treuhand & Steuer',
    notaries: 'Notare',
    wealth: 'Vermögensverwaltung',
    familyOffice: 'Family Offices',
  },
  trust: {
    title: 'Vertrauen durch Architektur',
    subtitle: 'Wir machen keine übertriebenen Versprechen. Wir bauen überprüfbare Garantien.',
    zeroKnowledge: 'Zero-Knowledge-Architektur',
    zeroKnowledgeDesc: 'Dokumente werden verschlüsselt, bevor sie unsere Infrastruktur erreichen. Wir können sie nicht lesen.',
    clientSide: 'Clientseitige Verschlüsselung',
    clientSideDesc: 'Alle kryptographischen Operationen finden in Ihrem Browser statt. Schlüssel verlassen Ihr Gerät nicht.',
    swissHosting: 'Schweizer Daten-Hosting',
    swissHostingDesc: 'Verschlüsselte Daten werden in der Schweiz gespeichert, unter Schweizer Datenschutzrecht.',
    dataMin: 'Datenminimierung',
    dataMinDesc: 'Wir speichern so wenig Informationen wie nötig, so kurz wie nötig.',
    openStandards: 'Offene kryptographische Standards',
    openStandardsDesc: 'Keine proprietäre Kryptographie. Überprüfbar, auditierbar, transparent.',
    noAds: 'Kein Tracking, keine Werbung',
    noAdsDesc: 'Keine Analytik, keine Pixel, keine Datenmonetarisierung. Niemals.',
  },
  dashboard: {
    greeting: 'Guten Tag',
    inbox: 'Posteingang',
    documents: 'Dokumente',
    secureLinks: 'Sichere Links',
    contacts: 'Kontakte',
    activity: 'Aktivität',
    settings: 'Einstellungen',
    newDeliveries: 'Neue Zustellungen',
    activeLinks: 'Aktive Links',
    storage: 'Speicher',
    securityStatus: 'Sicherheitsstatus',
    securityCenter: 'Sicherheitscenter',
    privacyDashboard: 'Datenschutz-Dashboard',
    recentActivity: 'Letzte Aktivität',
    createSecureLink: 'Sicheren Link erstellen',
    viewAll: 'Alle anzeigen',
    noItems: 'Keine Einträge vorhanden.',
    logout: 'Abmelden',
    secureInbox: 'Ihr Sicherer Posteingang',
    copy: 'Kopieren',
    new: 'Neu',
    viewed: 'Gesehen',
    downloaded: 'Heruntergeladen',
    document: 'Dokument',
    documentsPlural: 'Dokumente',
  },
  secureLink: {
    title: 'Sicheren Link erstellen',
    recipientName: 'Empfängername',
    recipientEmail: 'Empfänger-E-Mail (optional)',
    purpose: 'Zweck',
    expiration: 'Ablauf',
    maxUploads: 'Maximale Uploads',
    maxFileSize: 'Maximale Dateigrösse',
    accessCode: 'Zugangscode',
    accessCodeDefault: 'Standard: aktiviert (empfohlen)',
    accessCodeWarning: 'Ohne Zugangscode kann jeder mit dem Link Dateien hochladen. Der Zugangscode stellt sicher, dass nur die beabsichtigte Person Zugang hat.',
    oneTimeUse: 'Einmalige Verwendung',
    requireIdentification: 'Absender-Identifikation verlangen',
    deleteAfterDownload: 'Nach Download löschen',
    deleteAfterDays: 'Nach N Tagen löschen',
    allowReplies: 'Sichere Antworten erlauben',
    create: 'Link erstellen',
    copyLink: 'Link kopieren',
    showQR: 'QR-Code anzeigen',
    sendEmail: 'Per E-Mail senden',
    embedSnippet: 'Einbettungscode',
  },
  security: {
    title: 'Sicherheitscenter',
    authEnabled: 'Starke Authentifizierung aktiviert',
    recoveryConfigured: 'Wiederherstellung konfiguriert',
    trustedDevices: 'Vertrauenswürdige Geräte geprüft',
    retentionSet: 'Standard-Aufbewahrungsrichtlinie gesetzt',
    identityVerified: 'Berufliche Identität verifiziert',
    configure: 'Konfigurieren',
    configured: 'Konfiguriert',
  },
  recovery: {
    title: 'Wiederherstellung',
    subtitle: 'Stellen Sie sicher, dass Sie den Zugang zu Ihren verschlüsselten Daten nie verlieren.',
    disclaimer: 'Die Wiederherstellung gewährt Privatum zu keinem Zeitpunkt einseitigen Zugriff auf Ihre Dokumenteninhalte.',
    encryptedPackage: 'Verschlüsseltes Wiederherstellungspaket',
    trustedDevice: 'Vertrauenswürdiges Gerät',
    organizational: 'Organisatorische Wiederherstellung',
    shamir: 'Shamir Secret Sharing',
    trustedContacts: 'Vertrauenswürdige Kontakte',
  },
  onboarding: {
    title: 'Ihr sicherer Kanal wird erstellt',
    handle: 'Ihr Privatum-Handle',
    handleHint: 'Ihre permanente Adresse: privatum.ch/',
    name: 'Vollständiger Name',
    professionalTitle: 'Berufliche Bezeichnung',
    jurisdiction: 'Zuständigkeitsgebiet',
    photo: 'Foto / Logo (optional)',
    retention: 'Standard-Aufbewahrung',
    continue: 'Weiter',
    complete: 'Kanal erstellen',
    recoveryPrompt: 'Möchten Sie jetzt die Wiederherstellung einrichten?',
    recoveryLater: 'Später einrichten',
    recoveryNow: 'Jetzt einrichten',
  },
  footer: {
    tagline: 'Confidential by design.',
    security: 'Sicherheit & Vertrauen',
    legal: 'Rechtliches',
    privacy: 'Datenschutz',
    terms: 'AGB',
    imprint: 'Impressum',
    contact: 'Kontakt',
    vibed: 'Vibed with Shakespeare',
  },
  vault: {
    title: 'Vault',
    newFolder: 'Neuer Ordner',
    documents: 'Dokumente',
    permissions: 'Berechtigungen',
    allEncrypted: 'Alle Daten sind clientseitig verschlüsselt.',
    encrypted: 'verschlüsselt',
    folders: 'Ordner',
    searchPlaceholder: 'Suchen …',
    resultsFor: 'Ergebnis(se) für',
    noDocuments: 'Keine Dokumente gefunden.',
    folderEmpty: 'Dieser Ordner ist leer. Verschieben Sie Dokumente aus dem Posteingang hierher.',
    shareAccess: 'Zugriff teilen',
    rename: 'Umbenennen',
    secureDelete: 'Sicher löschen',
    decrypting: 'Dokument wird entschlüsselt',
    downloading: 'Download',
    deleting: 'wird sicher gelöscht.',
    folderCreated: 'Ordner erstellt.',
    folderDeleted: 'Ordner wird gelöscht.',
    createFolder: 'Ordner erstellen',
    newVaultFolder: 'Neuer Vault-Ordner',
    folderName: 'Name',
    folderNamePlaceholder: 'Nachlasssache Müller',
    folderDescription: 'Beschreibung (optional)',
    folderDescPlaceholder: 'Erbschaftsangelegenheiten Familie Müller',
    grantedPermissions: 'Erteilte Zugriffsberechtigungen',
    grantedPermissionsDesc: 'Kryptographisch signierte Zugriffserteilungen. Widerruf ist real: Schlüssel werden rotiert, Berechtigungen verfallen.',
    permissionLevels: 'Berechtigungsstufen',
    permView: 'Ansehen',
    permViewDesc: 'Empfänger kann das Dokument im Browser entschlüsseln und anzeigen.',
    permDownload: 'Herunterladen',
    permDownloadDesc: 'Empfänger kann das entschlüsselte Dokument lokal speichern.',
    permForward: 'Weiterleiten',
    permForwardDesc: 'Empfänger kann den verschlüsselten Zugriff an Dritte übertragen.',
    permDelegate: 'Delegieren',
    permDelegateDesc: 'Empfänger kann selbst Berechtigungen an andere erteilen.',
    uploadFile: 'Datei hochladen',
    uploadTitle: 'Datei verschlüsseln & speichern',
    uploadDragDrop: 'Dateien hierher ziehen oder klicken',
    uploadSelectFiles: 'Dateien auswählen',
    uploadEncrypting: 'Wird verschlüsselt …',
    uploadStoring: 'Wird gespeichert …',
    uploadComplete: 'Verschlüsselt & gespeichert.',
    retentionPolicy: 'Aufbewahrung',
    retentionManual: 'Manuell löschen',
    retentionAfterDownload: 'Nach Download löschen',
    retention24h: 'Nach 24 Stunden',
    retention7d: 'Nach 7 Tagen',
    retention30d: 'Nach 30 Tagen',
    retention90d: 'Nach 90 Tagen',
    retention1y: 'Nach 1 Jahr',
    openVault: 'Vault öffnen',
    encryptedDocuments: 'Verschlüsselte Dokumente',
    foldersMatters: 'Ordner / Mandate',
    activePermissions: 'Aktive Berechtigungen',
    vaultDesc: 'Vault — Verschlüsselter Dokumentenspeicher',
    vaultSubDesc: 'Mandate, Fälle und Ordner mit clientseitiger Verschlüsselung. Kryptographische Zugriffsberechtigungen mit Widerruf.',
    revokeAccess: 'Zugriff widerrufen',
    revokedFor: 'Zugriff für',
    revoked: 'widerrufen.',
    deletion: 'Löschung',
    accessTo: 'Zugriff auf',
    grantedAt: 'Erteilt',
    expiresAt: 'Ablauf',
    active: 'Aktiv',
    expired: 'Abgelaufen',
    revokedStatus: 'Widerrufen',
    inbox: 'Posteingang',
    manualUpload: 'Manuell hochgeladen',
    secureLink: 'Sicherer Link',
    pendingDeletion: 'Löschung',
  },
  audit: {
    title: 'Prüfprotokoll',
    subtitle: 'Kryptographisch verkettete Integritätsnachweise. Jeder Eintrag referenziert den vorherigen Hash.',
    chainValid: 'Integritätskette gültig',
    chainInvalid: 'Integritätskette fehlerhaft bei Eintrag',
    verifyChain: 'Kette verifizieren',
    verifying: 'Wird verifiziert …',
    verified: 'Verifiziert',
    entries: 'Einträge',
    documentHash: 'Dokument-Hash',
    entryHash: 'Eintrag-Hash',
    previousHash: 'Vorheriger Hash',
    direction: 'Richtung',
    inbound: 'Eingehend',
    outbound: 'Ausgehend',
    channel: 'Kanal',
    noEntries: 'Noch keine Integritätseinträge.',
    noEntriesDesc: 'Laden Sie Dateien in den Vault hoch oder empfangen Sie Dokumente — jede Aktion wird in der Integritätskette aufgezeichnet.',
    eventEncrypt: 'Verschlüsselt & gespeichert',
    eventUpload: 'Hochgeladen',
    eventDownload: 'Heruntergeladen',
    eventDelete: 'Gelöscht',
    eventMove: 'In Vault verschoben',
    eventDelivery: 'Zustellung empfangen',
    genesis: 'Genesis',
    timestamp: 'Zeitstempel',
    filename: 'Dateiname',
    fileSize: 'Dateigrösse',
    copyHash: 'Hash kopieren',
    allChannels: 'Alle Kanäle',
    filterByChannel: 'Nach Kanal filtern',
    privacyEncryptedStorage: 'Verschlüsselter Speicher',
    privacyUsed: 'Belegt',
    privacyScheduledDeletions: 'Geplante Löschungen',
    privacyScheduledDeletionsDesc: 'Dokumente, die automatisch gelöscht werden.',
    privacyExpiredLinks: 'Abgelaufene Links',
    privacyMetadataRetained: 'Aufbewahrte Metadaten',
    privacyMetadataRetainedDesc: 'Privatum speichert nur minimale Metadaten. Dokumenteninhalte sind nie Teil davon.',
    privacyDataMinStatement: 'Privatum ist darauf ausgelegt, so wenig Informationen wie nötig zu speichern, so kurz wie nötig.',
    privacyDataMinSubtext: 'Dokumenteninhalte werden verschlüsselt, bevor sie unsere Infrastruktur erreichen. Wir können sie nicht lesen.',
    privacyPanicDelete: 'Notfall-Löschung',
    privacyPanicDeleteDesc: 'Löscht alle verschlüsselten Dokumente und Metadaten unwiderruflich. Diese Aktion kann nicht rückgängig gemacht werden.',
    privacyPanicDeleteBtn: 'Alle Daten unwiderruflich löschen',
    privacyPanicConfirmTitle: 'Notfall-Löschung bestätigen',
    privacyPanicConfirmDesc: 'Diese Aktion löscht unwiderruflich alle verschlüsselten Dokumente, Metadaten, Sichere Links und Aktivitätsprotokolle.',
    privacyPanicConfirmPrompt: 'Geben Sie LÖSCHEN ein, um zu bestätigen:',
    privacyPanicConfirmWord: 'LÖSCHEN',
    privacyPanicConfirmBtn: 'Unwiderruflich löschen',
  },
  common: {
    loading: 'Wird geladen …',
    error: 'Ein Fehler ist aufgetreten.',
    retry: 'Erneut versuchen',
    cancel: 'Abbrechen',
    save: 'Speichern',
    delete: 'Löschen',
    back: 'Zurück',
    next: 'Weiter',
    close: 'Schliessen',
    download: 'Herunterladen',
    copy: 'Kopieren',
    copied: 'Kopiert',
    search: 'Suchen',
  },
} as const;
